import { axiosPrivate } from "./axios";

const resubmitOnboardingForm = async ({ storeId, token }) =>
  await axiosPrivate
    .post(
      `/doordash-v2-service/onboarding/confirm-store-onboarding-request`,
      {
        storeId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then(({ data }) => data);

export default resubmitOnboardingForm;
